module.exports = __webpack_public_path__ + "static/media/present.23ffcf51.png";